import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VSheet, [
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c(
          "div",
          {
            staticClass: "font-weight-light text-h6",
            staticStyle: { float: "left" },
          },
          [_vm._v(_vm._s(_vm.id))]
        ),
        _c(
          "div",
          {
            staticClass: "d-flex justify-center my-5",
            style: `font-size: ${_vm.headerFontSize}px`,
          },
          [
            _vm.processType
              ? _c("div", [
                  _vm.processDirection == "Input"
                    ? _c("span", [_vm._v("(In)")])
                    : _vm._e(),
                  _vm.processDirection == "Output"
                    ? _c("span", [_vm._v("(Out)")])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.processType.name) + " "),
                ])
              : _vm._e(),
            _vm.product && _vm.processType
              ? _c(VDivider, {
                  staticClass: "mx-3",
                  attrs: { vertical: "" },
                })
              : _vm._e(),
            _vm.product
              ? _c("div", [_vm._v(" " + _vm._s(_vm.product.name) + " ")])
              : _vm._e(),
            _vm.location
              ? _c(VDivider, {
                  staticClass: "mx-3",
                  attrs: { vertical: "" },
                })
              : _vm._e(),
            _vm.location
              ? _c("div", [_vm._v(" " + _vm._s(_vm.location.name) + " ")])
              : _vm._e(),
          ],
          1
        ),
        _c("qriously", { attrs: { value: _vm.qrCodeUrl, size: _vm.qrSize } }),
        _vm.memo
          ? _c("div", { style: `font-size: ${_vm.memoFontSize}px` }, [
              _vm._v(" " + _vm._s(_vm.memo) + " "),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "d-flex flex-column justify-center my-6 d-print-none",
          },
          [
            _c("a", { attrs: { href: _vm.qrCodeUrl } }, [
              _vm._v(_vm._s(_vm.qrCodeUrl)),
            ]),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(VTextField, {
                  staticClass: "mx-4 my-4",
                  attrs: { outlined: "", label: "QR Size" },
                  model: {
                    value: _vm.qrSize,
                    callback: function ($$v) {
                      _vm.qrSize = $$v
                    },
                    expression: "qrSize",
                  },
                }),
                _c(VTextField, {
                  staticClass: "mx-4 my-4",
                  attrs: { outlined: "", label: "Header Font Size" },
                  model: {
                    value: _vm.headerFontSize,
                    callback: function ($$v) {
                      _vm.headerFontSize = $$v
                    },
                    expression: "headerFontSize",
                  },
                }),
                _c(VTextField, {
                  staticClass: "mx-4 my-4",
                  attrs: { outlined: "", label: "Memo Font Size" },
                  model: {
                    value: _vm.memoFontSize,
                    callback: function ($$v) {
                      _vm.memoFontSize = $$v
                    },
                    expression: "memoFontSize",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "my-2" },
              [
                _c(
                  VBtn,
                  {
                    staticClass: "mx-4",
                    on: {
                      click: function ($event) {
                        return _vm.goBack()
                      },
                    },
                  },
                  [_vm._v("Back")]
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "mx-4",
                    on: {
                      click: function ($event) {
                        return _vm.print()
                      },
                    },
                  },
                  [_vm._v("Print")]
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "mx-4",
                    on: {
                      click: function ($event) {
                        return _vm.edit()
                      },
                    },
                  },
                  [_vm._v("Edit")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }